interface IProps {
    message: string
}

const HeaderMessage = ({message}: IProps) => {
    return <h3 className="font-normal text-[18px] sm:text-[22px] tracking-header mt-[10px] mb-[10px]">{message}</h3>
}

export default HeaderMessage
